module.exports = __webpack_public_path__ + "img/full2-min.87184f30.png";